module.exports = __webpack_public_path__ + "static/media/ic-search.f784411c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-search.svg
// module id = 660
// module chunks = 14